/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelMessage = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base = ''
    return { base: base, option: '' }
  },
  populate: function () {
    var base = this.template().base
    setTimeout(this.after.bind(this), this.getNaturalDelay('short'))
    return base
  },
  after: function () {
    var value = ''
    if (this.data.meta && this.data.meta.answer) {
      this.populateAnswer(
        function (value) {
          var answerData = {
            answer: {
              value: value,
              content: value,
              render: false,
            },
          }
          this.answerCallback(this.data, answerData, true)
        }.bind(this),
        this.data.meta.answer
      )
      return
    }
    var answerData = {
      answer: {
        value: value,
        content: value,
        render: false,
      },
    }
    this.answerCallback(this.data, answerData, true)
  }
})
